export default __webpack_public_path__ + "static/graphql-0e8c69ca8f48b17e9ed1b50123451716.png";